import { useAppSelector } from '~/store/reduxHooks';
import {
  selectIsMergeModified,
  selectSnippetActiveOperation,
  selectWorkflowOperationDescs,
} from 'flow/store/redux/selectors';
import InfoToolbar from './InfoToolbar';
import { useContext, useMemo } from 'react';
import { findLastOperation } from 'flow/service/assistance';
import { RuleBuilderContext } from '../context';
import { OperationMessageType } from 'flow/store/engine/types';
import { isEditable } from '../helpers';
import { ContainerType } from '../../types';
import AssistanceToolbar from './AssistanceToolbar';
import { getIsLinkedSnippetUpgradeOp } from 'flow/service/snippets/snippets';

const RuleBuilderToolbar = () => {
  const { containerType, editMode, sourceAction } = useContext(RuleBuilderContext);
  const sourceActionId = sourceAction?.publicId ?? '';
  const isMergeModified = useAppSelector(selectIsMergeModified(sourceActionId));
  const operationDescriptions = useAppSelector(selectWorkflowOperationDescs);
  const { operation: activeSnippetOperation } = useAppSelector(selectSnippetActiveOperation);

  const isDrawerOrIsland = [ContainerType.DRAWER, ContainerType.ISLAND]
    .includes(containerType);

  const isUpgradeSnippetFlow = getIsLinkedSnippetUpgradeOp(activeSnippetOperation);

  const relevantEngineAssistanceData = useMemo(
    () => findLastOperation({
      operations: operationDescriptions,
      publicId: sourceActionId,
      types: [
        OperationMessageType.actionRuleThreshold,
        OperationMessageType.undo,
      ],
    }),
    [operationDescriptions, sourceActionId]);

  if (isMergeModified && isDrawerOrIsland) {
    return <InfoToolbar isUpgradeSnippetFlow={isUpgradeSnippetFlow} />;
  }

  if (
    relevantEngineAssistanceData
      && isEditable(editMode)
      && isDrawerOrIsland
  ) {
    return (
      <AssistanceToolbar
        assistanceMessageObject={relevantEngineAssistanceData}
      />
    );
  }

  return null;
};

export default RuleBuilderToolbar;
